import { defineStore } from 'pinia'
import { fetchBetVouchers } from '@ms/api/voucher'

export const useBetVouchersStore = defineStore('betVouchers', {
  state: () => ({
    // 优惠券类型，默认 1 - realsport, 2 - virtual, 3 - jackpot
    bizType: 1,
    // response vouchers
    voucherList: [],
    // 当前选中红包
    selectedVoucher: null
  }),
  getters: {
    totalVoucherSize() {
      return this.voucherList.length
    }
  },
  actions: {
    reset() {
      this.voucherList.splice(0)
      this.selectedVoucher = null
    },
    // 设置 voucherList
    setResVouchers(arr) {
      this.voucherList = arr.map((x) => {
        return {
          ...x,
          amountLong: x.amountLong / 10000,
          totalLong: x.totalLong / 10000
        }
      })
    },
    // 更新红包
    updateVoucher(voucher = null) {
      this.selectedVoucher = voucher
    },
    /**
     * 获取 vouchers
     */
    async getVouchers(bizType = 1) {
      if (bizType !== this.bizType) {
        this.reset()
      }
      this.bizType = bizType
      const body = {
        bizType,
        status: [1]
      }
      try {
        const data = await fetchBetVouchers(body)
        this.setResVouchers(data)
      } catch (error) {
        this.reset()
        console.error(error)
        return Promise.reject(error)
      }
    }
  }
})
